import axios, { type InternalAxiosRequestConfig } from "axios";

/**
 * Configure axios to send session token from localStorage
 * This must be imported before any component that uses axios
 */
axios.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const token = localStorage.getItem("session_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  }
);

export default axios;
